/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { DateSearch } from './DateSearch';
import {
    DateSearchFromJSON,
    DateSearchFromJSONTyped,
    DateSearchToJSON,
} from './DateSearch';
import type { Int32ListSearch } from './Int32ListSearch';
import {
    Int32ListSearchFromJSON,
    Int32ListSearchFromJSONTyped,
    Int32ListSearchToJSON,
} from './Int32ListSearch';

/**
 * 
 * @export
 * @interface SiegeLieuSuiviSearchBase
 */
export interface SiegeLieuSuiviSearchBase {
    /**
     * 
     * @type {Int32ListSearch}
     * @memberof SiegeLieuSuiviSearchBase
     */
    idrealisateurSuivi?: Int32ListSearch;
    /**
     * 
     * @type {DateSearch}
     * @memberof SiegeLieuSuiviSearchBase
     */
    dateSuivi?: DateSearch;
    /**
     * 
     * @type {Int32ListSearch}
     * @memberof SiegeLieuSuiviSearchBase
     */
    idtypeSuivi?: Int32ListSearch;
    /**
     * 
     * @type {number}
     * @memberof SiegeLieuSuiviSearchBase
     */
    idsiegeSocial?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SiegeLieuSuiviSearchBase
     */
    idlieuFormation?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SiegeLieuSuiviSearchBase
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof SiegeLieuSuiviSearchBase
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof SiegeLieuSuiviSearchBase
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SiegeLieuSuiviSearchBase
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof SiegeLieuSuiviSearchBase
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof SiegeLieuSuiviSearchBase
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the SiegeLieuSuiviSearchBase interface.
 */
export function instanceOfSiegeLieuSuiviSearchBase(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SiegeLieuSuiviSearchBaseFromJSON(json: any): SiegeLieuSuiviSearchBase {
    return SiegeLieuSuiviSearchBaseFromJSONTyped(json, false);
}

export function SiegeLieuSuiviSearchBaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SiegeLieuSuiviSearchBase {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idrealisateurSuivi': !exists(json, 'idrealisateurSuivi') ? undefined : Int32ListSearchFromJSON(json['idrealisateurSuivi']),
        'dateSuivi': !exists(json, 'dateSuivi') ? undefined : DateSearchFromJSON(json['dateSuivi']),
        'idtypeSuivi': !exists(json, 'idtypeSuivi') ? undefined : Int32ListSearchFromJSON(json['idtypeSuivi']),
        'idsiegeSocial': !exists(json, 'idsiegeSocial') ? undefined : json['idsiegeSocial'],
        'idlieuFormation': !exists(json, 'idlieuFormation') ? undefined : json['idlieuFormation'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function SiegeLieuSuiviSearchBaseToJSON(value?: SiegeLieuSuiviSearchBase | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idrealisateurSuivi': Int32ListSearchToJSON(value.idrealisateurSuivi),
        'dateSuivi': DateSearchToJSON(value.dateSuivi),
        'idtypeSuivi': Int32ListSearchToJSON(value.idtypeSuivi),
        'idsiegeSocial': value.idsiegeSocial,
        'idlieuFormation': value.idlieuFormation,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

